/* eslint-disable import/prefer-default-export */
export const updateStorageItem = (itemKey, value) => {
  if (value) {
    localStorage.setItem(itemKey, value);
  } else {
    localStorage.removeItem(itemKey);
  }
};
